import { useState, useEffect } from "react";
import Loading from "../components/global/Loading";
import { devURL } from "../constants/constants";
import SelectStation from "../components/tankstemperatures/SelectStation";
import '../styles/tankstemperatures.css';
import axios from "axios";
import CurrentsData from "../components/tankstemperatures/CurrentsData";

export default function TankTemperatures() {
    const [ station, setStation ] = useState("AX002");
    const [ data, setData ] = useState(null);

    useEffect( () => {
        async function getData() {
            setData(false)
            try {
                setData(null);
                await axios({
                    method: 'get',
                    url: `${devURL}/get-tank-temperatures?station=${station}`
                }).then(response => setData(response.data))
            } catch(error) {
                console.log(error)
            }
        };
        getData();
    }, [station]);

    return (
        <>
            <h1>Temperatury zbiorników</h1>
            <h6>Nieaktywne.</h6>
            {/* <SelectStation setStation={setStation}/>
            { !data ? <Loading/> : <CurrentsData data={data}/> } */}
        </>
    )
    
}